module.exports = __webpack_public_path__ + "media/images/how-it-works/arena/step-4-3b74630cd07562bfd57a5bfcc8895382.png";